const cybRoutes = [
	{
		path: '/cyb',
		name: 'cyb-admin',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'admin', scene: 'dashboard' },
		meta: {
			name: 'Cybersecurity Admin',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app', 'use.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/admin/dashboard',
		name: 'cyb-admin-dashboard',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'admin', scene: 'dashboard' },
		meta: {
			name: 'Cybersecurity Dashboard',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app', 'use.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/admin/assets',
		name: 'cyb-admin-assets',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'admin', scene: 'assets' },
		meta: {
			name: 'Assets',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app', 'use.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/admin/assets-old',
		name: 'cyb-admin-assets-old',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'admin', scene: 'assets_old' },
		meta: {
			name: 'Assets (Old)',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app', 'use.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/admin/asset-types',
		name: 'cyb-admin-asset-types',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'admin', scene: 'asset_types' },
		meta: {
			name: 'Asset Types',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app', 'use.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/admin/threats',
		name: 'cyb-admin-threats',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'admin', scene: 'threats' },
		meta: {
			name: 'Threats',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app', 'use.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/admin/assessments',
		name: 'cyb-admin-assessments',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'admin', scene: 'assessments' },
		meta: {
			name: 'Risk Assessments',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app', 'use.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/admin/heatmap',
		name: 'cyb-admin-heatmap',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'admin', scene: 'heatmap' },
		meta: {
			name: 'Cybersecurity Heatmap',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app', 'use.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/admin/control-runs',
		name: 'cyb-admin-control-runs',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'admin', scene: 'control_runs' },
		meta: {
			name: 'Control Runs',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app', 'use.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/tasks',
		name: 'cyb-tasks',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'tasks' },
		meta: {
			name: 'Cybersecurity Tasks',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app', 'use.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/tasks/:uuid',
		name: 'cyb-tasks-resource',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'tasks' },
		meta: {
			name: 'Cybersecurity Tasks',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app', 'use.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/admin/controls',
		name: 'cyb-admin-controls',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'admin', scene: 'controls' },
		meta: {
			name: 'Controls',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app', 'use.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/admin/cycles',
		name: 'cyb-admin-cycles',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'admin', scene: 'cycles' },
		meta: {
			name: 'Cybersecurity Cycles',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/admin/users',
		name: 'cyb-admin-users',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'admin', scene: 'users' },
		meta: {
			name: 'Cybersecurity Users',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/asset-types',
		name: 'cyb-asset-types',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'asset_types' },
		meta: {
			name: 'Asset Types',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app', 'use.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/threats',
		name: 'cyb-threats',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'threats' },
		meta: {
			name: 'Threats',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app', 'use.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/controls',
		name: 'cyb-controls',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'controls' },
		meta: {
			name: 'Controls',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app', 'use.apps.cyb.app'],
		},
	},

	{
		path: '/cyb/heatmap',
		name: 'cyb-heatmap',
		component: () => import('@/apps/cyb/Home.vue'),
		props: { view: 'heatmap' },
		meta: {
			name: 'Cybersecurity Heatmap',
			permissions: ['admin.apps.cyb.app', 'manage.apps.cyb.app', 'use.apps.cyb.app'],
		},
	},
]

export default cybRoutes
